<bsh-week-calendar
  [rooms]="calendarRows()"
  [isLoading]="isLoading()"
  [sortDirection]="sortDirection()"
  [initialDate]="initialDate()"
  [canAddEvent]="true"
  [canOpenRoom]="true"
  [canOpenEvent]="false"
  (addEvent)="onAddEvent($event)"
  (roomClick)="onRoomClick($event)"
  (weekChange)="onWeekChange($event)"
  [hideWeekends]="true"
  (sortChange)="onSortChange($event)">
</bsh-week-calendar>
